import React, { ReactNode } from 'react';
import { Dialog } from 'primereact/dialog';
import AnimatedButton from './AnimatedButton';
import Icon from '../../icons/Icon';

interface CustomConfirmDialogProps {
  visible: boolean;
  onHide: () => void;
  title: ReactNode;
  description?: ReactNode;
  body?: ReactNode;
  icon?: ReactNode;
  cancelLabel: ReactNode;
  confirmLabel: ReactNode;
  onConfirm: () => void | Promise<void>;
}

const CustomConfirmDialog = ({
  visible,
  onHide,
  title,
  description,
  body,
  icon,
  cancelLabel,
  confirmLabel,
  onConfirm,
}: CustomConfirmDialogProps) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      closable={false}
      dismissableMask
      className='w-[462px] !rounded-lg shadow-lg'
      headerClassName='!p-5'
      contentClassName={body != undefined ? '!overflow-hidden' : undefined}
      maskClassName='!bg-black !bg-opacity-30'
      header={
        <div className='flex w-full justify-end'>
          <button type='button' className='flex h-5 w-5 items-center' onClick={onHide}>
            <Icon icon='close' />
          </button>
        </div>
      }
    >
      <div className={body != undefined ? 'flex max-h-[calc(90vh-6.75rem)] py-2 2xl:py-3 flex-col items-center gap-y-5 overflow-hidden' : 'flex flex-col items-center gap-y-5'}>
        {icon != undefined && <div className='shrink-0'>{icon}</div>}
        <div className={body != undefined ? 'flex min-h-0 w-full flex-col gap-y-2 overflow-hidden px-5' : 'flex w-full flex-col gap-y-2 px-5'}>
          <div className='shrink-0 text-center text-xl font-semibold text-f-black-1'>{title}</div>
          {description != undefined && <div className='shrink-0 max-w-md text-center text-xs text-f-black-3'>{description}</div>}
          {body != undefined && <div className='custom-scroll min-h-0 flex-auto overflow-y-auto overscroll-contain'>{body}</div>}
        </div>
        <div className='flex shrink-0 justify-center gap-x-4'>
          <AnimatedButton icon='close' text={String(cancelLabel)} customType='outlined' onClick={onHide} />
          <AnimatedButton icon='delete' text={String(confirmLabel)} customType='fraud' onClick={onConfirm} />
        </div>
      </div>
    </Dialog>
  );
};

export default CustomConfirmDialog;
